import React from 'react';
import { bool, func, number, string } from 'prop-types';
import classNames from 'classnames/bind';

import useStyles from 'hooks/useStyles';
import useGetFreeTrialInfo from 'hooks/useGetFreeTrialInfo';

import { MessageIcon } from 'components/Icon';

import styles from './GetFreeTrialLink.scss';

const cx = classNames.bind(styles);

export default function GetFreeTrialLink({
  isShow,
  className,
  onClick,
  id,
  name,
  section,
  type,
}) {
  useStyles(styles);

  const {
    linkText,
    isAllowFreeTrialRegion,
    handleTriggerFreeTrialLink,
  } = useGetFreeTrialInfo({
    id,
    name,
    section,
    type,
  });

  const handleClick = event => {
    event.preventDefault();
    handleTriggerFreeTrialLink();
    onClick(event);
  };

  if (!isAllowFreeTrialRegion || !isShow) return null;
  return (
    <div className={cx(styles.root, className)} onClick={handleClick}>
      <div>{linkText}</div>
      <MessageIcon className={styles.icon} />
    </div>
  );
}

GetFreeTrialLink.propTypes = {
  className: string,
  isShow: bool,
  onClick: func,
  id: number,
  name: string,
  section: string,
  type: string,
};

GetFreeTrialLink.defaultProps = {
  className: '',
  isShow: true,
  onClick: () => {},
  id: '',
  name: '',
  section: '',
  type: '',
};
